const Button = ({ text, onClick, className, type = "submit" }) => {
  return (
    <button
      onClick={onClick}
      type={type}
      className={`text-white rounded-lg py-2 px-6 text-xl capitalize ${className}`}
    >
      {text}
    </button>
  );
};

export default Button;
